import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import Select from "react-select";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStaff } from "../../store/slices/staff";
import { getClassSubject } from "../../store/slices/subject";
import { addSubjectTeacher } from "../../store/slices/subjectteacher";
import { FiHome, FiChevronRight } from "react-icons/fi";

export default function AddSubjectTeacher() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [teacherId, setTeacherId] = useState("");

  const [assignments, setAssignments] = useState([
    {
      standardId: "",
      sectionId: "",
      subjectIds: [],
      sections: [],
      subjects: [],
    },
  ]);

  const [errors, setErrors] = useState({});

  const { classsectionList = [] } = useSelector(
    (state) => state.classsection || {}
  );


  const { staffList = [] } = useSelector((state) => state.staff || {});


  const addAssignment = () => {
    setAssignments((prev) => [
      ...prev,
      {
        standardId: "",
        sectionId: "",
        subjectIds: [],
        sections: [],
        subjects: [],
      },
    ]);
  };

  const removeAssignment = (index) => {
    setAssignments((prev) => prev.filter((_, i) => i !== index));
  };
  useEffect(() => {
    dispatch(fetchStandardSection());
    dispatch(getStaff());
  }, [dispatch]);

  const standards = [
    ...new Map(
      classsectionList.map((item) => [
        item.standardId._id,
        item.standardId,
      ])
    ).values(),
  ];

  const handleSubjectsChange = (index, values) => {
    const updated = [...assignments];
    updated[index].subjectIds = values;
    setAssignments(updated);
    setErrors((prev) => ({
      ...prev,
      [`subjectIds_${index}`]: "",
    }));
  };

  const handleAssignmentChange = async (index, name, value) => {
    const updated = [...assignments];

    updated[index][name] = value;

    setErrors((prev) => ({
      ...prev,
      [`${name}_${index}`]: "",
    }));

    if (name === "standardId") {
      // Reset dependent fields
      updated[index].sectionId = "";
      updated[index].subjectIds = [];
      updated[index].subjects = [];
      updated[index].sections = [];

      // Find selected standard
      const selectedStandard = classsectionList.find(
        (item) => item.standardId?._id === value
      );

      if (selectedStandard) {
        updated[index].sections = selectedStandard.sectionId || [];
      }

      // Load subjects for the selected standard
      try {
        const subjectRes = await dispatch(
          getClassSubject({ standardId: value })
        ).unwrap();

        const response = subjectRes.data || subjectRes || [];

        updated[index].subjects =
          response.length > 0 ? response[0].subjectId : [];
      } catch (err) {
        console.log(err);
      }
    }

    setAssignments(updated);
  };


  const validate = () => {
    const newErrors = {};

    if (!teacherId) {
      newErrors.teacherId = "Please select teacher";
    }

    assignments.forEach((row, index) => {
      if (!row.standardId) {
        newErrors[`standardId_${index}`] = "Please select standard";
      }

      if (!row.sectionId) {
        newErrors[`sectionId_${index}`] = "Please select section";
      }

      if (!row.subjectIds.length) {
        newErrors[`subjectIds_${index}`] =
          "Please select at least one subject";
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      teacherId,
      assignments: assignments.map((row) => ({
        standardId: row.standardId,
        sectionId: row.sectionId,
        subjectIds: row.subjectIds,
      })),
    };

    dispatch(addSubjectTeacher(payload))
      .unwrap()
      .then(() => {
        toast.success("Subject teacher added successfully");
        navigate("/institute/subjectteachers");
      })
      .catch((err) => {
        toast.error(err || "Failed to add subject teacher");
      });
  };

  const teacherOptions = staffList
    .filter(
      (staff) =>
        staff.dept === "Teaching" &&
        staff.status === 1 &&
        !staff.isDeleted
    )
    .map((staff) => ({
      value: staff._id,
      label: staff.name,
    }));

  return (
    <>
      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />
            <Link to="/institute/subjectteachers">Subject Teacher</Link>

            <FiChevronRight className="separator" />

            <span className="active">Add Subject Teacher</span>
          </div>


        </div>

      </div>
      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3 mb-3">
            <Col md={3}>
              <Form.Label>Teacher</Form.Label>

              <Select
                placeholder="Select Teacher"
                isSearchable
                options={teacherOptions}
                value={
                  teacherOptions.find(
                    (option) => option.value === teacherId
                  ) || null
                }
                onChange={(selectedOption) => {
                  setTeacherId(selectedOption ? selectedOption.value : "");

                  setErrors((prev) => ({
                    ...prev,
                    teacherId: "",
                  }));
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "38px",
                    borderColor: "#ced4da",
                    boxShadow: "none",
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
              {errors.teacherId && (
                <small className="text-danger">{errors.teacherId}</small>
              )}
            </Col>
          </Row>
          <Row>
            <br />

            {assignments.map((item, index) => (
              <div key={index} className="border rounded p-3 mb-3">

                <Row>

                  <Col md={3}>
                    <Form.Label>Standard</Form.Label>

                    <Form.Select
                      value={item.standardId}
                      onChange={(e) =>
                        handleAssignmentChange(index, "standardId", e.target.value)
                      }
                    >
                      <option value="">Select Standard</option>

                      {classsectionList.map((item) => (
                        <option
                          key={item.standardId._id}
                          value={item.standardId._id}
                        >
                          {item.standardId.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors[`standardId_${index}`] && (
                      <small className="text-danger">
                        {errors[`standardId_${index}`]}
                      </small>
                    )}
                  </Col>

                  <Col md={3}>
                    <Form.Label>Section</Form.Label>

                    <Form.Select
                      value={item.sectionId}
                      disabled={!item.standardId}
                      onChange={(e) =>
                        handleAssignmentChange(index, "sectionId", e.target.value)
                      }
                    >
                      <option>Select Section</option>

                      {item.sections.map((s) => (
                        <option key={s._id} value={s._id}>
                          {s.name}
                        </option>
                      ))}
                    </Form.Select>
                    {errors[`sectionId_${index}`] && (
                      <small className="text-danger">
                        {errors[`sectionId_${index}`]}
                      </small>
                    )}
                  </Col>

                  <Col md={5}>
                    <Form.Label>Subject</Form.Label>
                    <Select
                      isDisabled={!item.standardId}
                      isMulti
                      placeholder="Select Subjects"
                      options={item.subjects.map((subject) => ({
                        value: subject._id,
                        label: subject.name,
                      }))}
                      value={item.subjects
                        .filter((subject) => item.subjectIds.includes(subject._id))
                        .map((subject) => ({
                          value: subject._id,
                          label: subject.name,
                        }))
                      }
                      onChange={(selected) =>
                        handleSubjectsChange(
                          index,
                          selected ? selected.map((x) => x.value) : []
                        )
                      }
                    />
                    {errors[`subjectIds_${index}`] && (
                      <small className="text-danger">
                        {errors[`subjectIds_${index}`]}
                      </small>
                    )}
                  </Col>
                  <Col md={1} className="d-flex align-items-end">

                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={addAssignment}
                    >
                      +
                    </button>

                    {assignments.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger ms-2"
                        onClick={() => removeAssignment(index)}
                      >
                        -
                      </button>
                    )}

                  </Col>

                </Row>
              </div>
            ))}
          </Row>
          <br />


          {/* Actions */}
          <div className="sta-actions mt-5">
            <button
              className="btn-cancel"
              type="submit"
              style={{ color: "black" }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button className="btn-submit" type="submit">
              Submit
            </button>
          </div>
        </Form>

      </div>
    </>
  );
}
